import { createFileRoute } from '@tanstack/react-router';
import { DREDashboard } from '../../../app/financial/dre';
import type { ComparisonMode, DREGranularity } from '../../../app/financial/dre/components';

// Valid granularity values for URL validation
const VALID_GRANULARITIES: DREGranularity[] = ['accumulated', 'yearly', 'quarterly', 'monthly'];
const VALID_COMPARISON_MODES: ComparisonMode[] = ['none', 'previous_period', 'same_period_last_year'];

export const Route = createFileRoute('/_auth/financial/dre/')({
  validateSearch: (search: Record<string, unknown>): {
    startDate?: string;
    endDate?: string;
    granularity?: DREGranularity;
    comparison?: ComparisonMode;
  } => ({
    startDate: typeof search.startDate === 'string' && search.startDate ? search.startDate : undefined,
    endDate: typeof search.endDate === 'string' && search.endDate ? search.endDate : undefined,
    granularity: VALID_GRANULARITIES.includes(search.granularity as DREGranularity)
      ? (search.granularity as DREGranularity)
      : undefined,
    comparison: VALID_COMPARISON_MODES.includes(search.comparison as ComparisonMode)
      ? (search.comparison as ComparisonMode)
      : undefined,
  }),
  component: DREDashboard,
})

